module.exports = __webpack_public_path__ + "img/shaman.ff330fc0.png";